import { Component, OnInit } from '@angular/core';
import { Router, Params, ActivatedRoute } from "@angular/router";
import { Helpers } from '@app/helpers/helpers.class';

// Services
import { AuthService } from '@app/services/auth.service';

@Component({
    selector: 'app-employees-list-admin-page',
    templateUrl: './employees-list.component.html',
    styleUrls: ['./employees-list.component.scss']
})

export class EmployeesListAdminComponent implements OnInit {
    employeeId: number;
    query: string;
    companyIds: number[];
    employmentTypeIds: number[];
    departmentIds: number[];
    registeredFrom: string;
    registeredTo: string;
    active: boolean;
    page: number;

    constructor(private authService: AuthService,
        private activatedRoute: ActivatedRoute,
        private router: Router) { }

    ngOnInit(): void {
        this.employeeId = this.authService.getEmployeeId();
        const params: Params = Object.assign({}, this.activatedRoute.snapshot.queryParams);

        if (Helpers.isDefined(params['query'])) {
            this.query = params['query'];
        }

        if (Helpers.isDefined(params['companyIds'])) {
            this.companyIds = params['companyIds'];
        }

        if (Helpers.isDefined(params['employmentTypeIds'])) {
            this.employmentTypeIds = params['employmentTypeIds'];
        }

        if (Helpers.isDefined(params['departmentIds'])) {
            this.departmentIds = params['departmentIds'];
        }

        if (Helpers.isDefined(params['registeredFrom'])) {
            this.registeredFrom = params['registeredFrom'];
        }

        if (Helpers.isDefined(params['registeredTo'])) {
            this.registeredTo = params['registeredTo'];
        }

        if (Helpers.isDefined(params['active'])) {
            this.active = params['active'];
        }

        if (Helpers.isDefined(params['page'])) {
            this.page = params['page'];
        }
    }

    updateQueryParameters(filter: any): void {
        const params: Params = Object.assign({}, this.activatedRoute.snapshot.queryParams);
        params['active'] = filter.active ? 1 : 0;
        params['companyIds'] = filter.companyIds.length > 0 ? filter.companyIds.join(',') : null;
        params['employmentTypeIds'] = filter.employmentTypeIds.length > 0 ? filter.employmentTypeIds.join(',') : null;
        params['departmentIds'] = filter.departmentIds.length > 0 ? filter.departmentIds.join(',') : null;
        params['registeredFrom'] = filter.registeredFrom.length > 0 ? filter.registeredFrom : null;
        params['registeredTo'] = filter.registeredTo.length > 0 ? filter.registeredTo : null;
        params['query'] = Helpers.isDefined(filter.query) && filter.query.length > 0 ?
            filter.query : null;
        params['page'] = filter.page;
        this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: params });
    }
}
